import msgManger from "../main/message/message-manager"

export function initMessage(hstRtcEngine) {
  /**
   * 发送单播消息
   * @param {*} params 
   */
  hstRtcEngine.prototype.sendUserMsg = function(params) {
    msgManger.sendUserMsg(params);
  };

  /**
   * 发送白名单消息
   * @param {*} params 
   */
  hstRtcEngine.prototype.sendGroupMsgWithWhiteList = function(params) {
    msgManger.sendGroupMsgWithWhiteList(params);
  };

  /**
   * 发送黑名单消息
   * @param {*} params 
   */
  hstRtcEngine.prototype.sendGroupMsgWithBlackList = function(params) {
    msgManger.sendGroupMsgWithBlackList(params);
  };

  /**
   * 发送广播消息
   * @param {*} params 
   */
  hstRtcEngine.prototype.sendGroupMsg = function(params) {
    msgManger.sendGroupMsg(params);
  };
}